module.exports = __webpack_public_path__ + "img/logo.870e2e83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = cH+4
// module chunks = 1